export class DocumentDownload {
  id: string;
  download_url: string;
}
